<template>
  <div class="fillcontain">
    <el-row :gutter="20">
      <el-col :span="4">
        <div class="grid-content bg-purple">
          日期:{{ this.courseDetails.courseDate }}
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content bg-purple">
          时间:{{ this.courseDetails.courseTime }}
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content bg-purple">
          课程类型:{{ this.courseDetails.courseType }}
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content bg-purple">
          课包:{{ this.courseDetails.coursePackages }}
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content bg-purple">
          课程地点:{{ this.courseDetails.courseLocation }}
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content bg-purple">
          教练:{{ this.courseDetails.courseCoachList }}
          <!-- <template v-for="coach in this.courseDetails.courseCoachList"
            >{{ coach.coachName }},</template
          > -->
        </div>
      </el-col>
      <!-- <el-col :span="4">
        <div class="grid-content">
          <el-button
            style="width:40%;height:100%;"
            type="danger"
            icon="delete"
            size="mini"
            @click="clockInDialogShow = true"
          >打卡</el-button>
        </div>
      </el-col> -->
      <el-col :span="4">
        <div class="grid-content">
          <el-button
            style="width: 40%; height: 100%"
            type="success"
            icon="delete"
            size="mini"
            @click="addStudentDialogShow = true"
            >添加</el-button
          >
        </div>
      </el-col>
    </el-row>
    <div class="table_container">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        border
        align="center"
        @select="selectTable"
        @select-all="selectAll"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          v-if="idFlag"
          prop="id"
          label="id"
          align="center"
        ></el-table-column>
        <el-table-column type="selection" align="left"></el-table-column>
        <el-table-column
          prop="studentName"
          label="学员姓名"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="studentAge"
          label="年龄"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="coursePerformance"
          label="课堂表现"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="recordNote"
          label="学习内容"
          align="left"
        ></el-table-column>
        <el-table-column prop="operation" align="left" label="操作">
          <template slot-scope="scope">
            <el-button
              type="warning"
              icon="edit"
              size="mini"
              @click="onEditRecord(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              icon="delete"
              size="mini"
              @click="onDeleteRecord(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :pageTotal="pageTotal"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
      <addFundDialog
        v-if="addCourseDialog.show"
        :isShow="addCourseDialog.show"
        :dialogRow="addCourseDialog.dialogRow"
        :courseTypeList="addCourseDialog.courseTypeList"
        :courseLocationList="addCourseDialog.courseLocationList"
        :courseDetails="addCourseDialog.courseDetails"
        :stdName="addCourseDialog.stdName"
        @getCourseList="getCourseRecordList"
        @closeDialog="hideAddFundDialog"
      ></addFundDialog>
      <el-dialog title="教练打卡" :visible.sync="clockInDialogShow">
        <el-form :model="clockInForm">
          <el-form-item label="教练名称" :label-width="formLabelWidth">
            <el-select
              v-model="clockInForm.coachName"
              placeholder="请选择教练名称"
            >
              <el-option
                v-for="item in coachList"
                :key="item.coachName"
                :value="item.coachName"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="clockInDialogShow = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit('clockInForm')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <el-dialog title="添加学员" :visible.sync="addStudentDialogShow">
        <el-form :model="studentInForm">
          <el-form-item required label="学生姓名" :label-width="formLabelWidth">
            <el-input
              :rows="2"
              type="text"
              v-model="studentInForm.stdName"
            ></el-input>
          </el-form-item>
          <el-form-item
            required
            label="会员手机号"
            :label-width="formLabelWidth"
          >
            <el-input
              :rows="2"
              type="text"
              @change="changeVal"
              v-model="studentInForm.telephoneNumber"
            ></el-input>
          </el-form-item>
          <el-form-item label="课堂表现" :label-width="formLabelWidth">
            <el-input
              :rows="2"
              type="textarea"
              v-model="studentInForm.coursePerformance"
            ></el-input>
          </el-form-item>
          <el-form-item label="学习内容" :label-width="formLabelWidth">
            <el-input
              :rows="2"
              type="textarea"
              v-model="studentInForm.recordNote"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item required label="课包类型" :label-width="formLabelWidth"> -->
          <!-- <el-select
              v-model="studentInForm.coursePackageId"
              placeholder="请选择课包类型"
            > -->
          <!-- <el-cascader
              v-model="studentInForm.coursePackageId"
              :options="options"
              collapse-tags
              :show-all-levels="false"
              clearable
            ></el-cascader> -->
          <!-- <el-option
                v-for="item in coursePackageList"
                :label="item.packageName"
                :key="item.name"
                :value="item.id"
              ></el-option> -->
          <!-- </el-select> -->
          <!-- </el-form-item> -->
          <!-- <el-form-item required label="课包购买日期">
            <el-date-picker
              v-model="studentInForm.buyDate"
              type="date"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item> -->
          <el-form-item required label="会员课包">
            <el-select
              v-model="studentInForm.coursePackageAndMemberId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in this.coursePackageAndMemberOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addStudentDialogShow = false">取 消</el-button>
          <el-button type="primary" @click="onSubmitStudent('studentInForm')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SearchItem from "./components/searchItem";
import AddFundDialog from "./components/addCourseDialog";
import Pagination from "@/components/pagination";
import { getRecordInfoByCourseId, addRecord, deleteRecord } from "@/api/record";
import { blindCoach } from "@/api/course";
import { getCoursePackages } from "@/api/coursepackage";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";
import { getFormatCoursePackagesForCourse } from "@/api/coursepackage";
import { getCoursePackageAndMemberByCoursePackageIdAndTelephone } from "@/api/memberCoursePackage";

export default {
  data() {
    return {
      props: { emitPath: false },
      options: [],
      tableData: [],
      courseTypeData: [],
      coursePackageList: [],
      courseLocationData: [],
      clockInDialogShow: false,
      addStudentDialogShow: false,
      tableHeight: 0,
      coursePackageAndMemberOption: [
        {
          value: "-1",
          label: "该会员没有这种类型的课包",
        },
      ],
      loading: false,
      idFlag: false,
      isShow: false, // 是否显示资金modal,默认为false
      editid: "",
      multipleSelection: [], //多选的数据
      sortnum: 0,
      format_course_type_list: {},
      format_course_location_list: {},
      formLabelWidth: "120px",
      clockInForm: {
        coachId: "",
      },
      studentInForm: {
        courseId: "",
        stdName: "",
        telephoneNumber: "",
        coursePerformance: "",
        recordNote: "",
        coursePackageId: "",
        buyDate: "",
        coursePackageAndMemberId: "",
      },
      addCourseDialog: {
        show: false,
        dialogRow: {},
        courseTypeList: {},
        courseLocationList: {},
        courseDetails: {},
        stdName: "",
      },
      coursePackageData: {
        page: 1,
        limit: 100,
      },
      courseData: {
        page: 1,
        limit: 20,
      },
      pageTotal: 0,
      // 用于列表筛选
      fields: {},
    };
  },
  components: {
    SearchItem,
    AddFundDialog,
    Pagination,
  },
  computed: {
    ...mapGetters(["courseSearch", "courseDetails", "coachList"]),
  },
  mounted() {
    this.getFormatCoursePackagesForCourse();
    this.getCourseRecordList();
    // this.getCoursePackageList();
  },
  methods: {
    changeVal() {
      // console.log(this.appointmentCourseDate.telephone);
      // const coursePackageId = val[1];
      // console.log(coursePackageId);
      getCoursePackageAndMemberByCoursePackageIdAndTelephone({
        // coursePackageId: coursePackageId,
        telephone: this.studentInForm.telephoneNumber,
      }).then((res) => {
        console.log(res);
        if (res.data.code === 200) {
          this.studentInForm.coursePackageAndMemberId = "";
          this.coursePackageAndMemberOption = res.data.data;
        } else {
          this.studentInForm.coursePackageAndMemberId = "-1";
          this.coursePackageAndMemberOption = [
            {
              value: "-1",
              label: "该会员没有这种类型的课包",
            },
          ];
        }
      });
    },
    getFormatCoursePackagesForCourse() {
      getFormatCoursePackagesForCourse().then((res) => {
        console.log("getFormatCoursePackagesForCourse");
        console.log(res);
        this.options = res.data.data;
      });
    },
    getCoursePackageList() {
      const para = this.coursePackageData;
      getCoursePackages(para).then((res) => {
        console.log("getCoursePackages:");
        console.log(res);
        this.coursePackageList = res.data.data.data;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log(this.multipleSelection);
    },
    setTableHeight() {
      this.$nextTick(() => {
        this.tableHeight = document.body.clientHeight - 300;
      });
    },

    getCourseRecordList() {
      let id = {
        courseId: this.courseDetails.id,
      };
      const para = Object.assign({}, this.courseData, id);
      console.log(para);
      getRecordInfoByCourseId(para).then((res) => {
        console.log(res);
        this.loading = false;
        this.pageTotal = res.data.data.total;
        this.tableData = res.data.data.recordData;
      });
    },
    // 显示资金弹框
    showAddCourseDialog(val) {
      // this.$store.commit("SET_COURSE_DIALOG_TITLE", val);
      this.addCourseDialog.show = true;
    },
    hideAddFundDialog() {
      this.addCourseDialog.show = false;
    },
    // 上下分页
    handleCurrentChange(val) {
      this.courseData.page = val;
      this.getCourseRecordList();
    },
    // 每页显示多少条
    handleSizeChange(val) {
      this.courseData.limit = val;
      this.getCourseRecordList();
    },
    /**
     * 格式化状态
     */
    filterCourseType(value, item) {
      return this.format_course_type_list[value] == item.courseType;
    },
    filterCourseLocation(value, item) {
      return this.format_course_location_list[value] == item.courseLocation;
    },
    formatterCourseType(item) {
      const type = parseInt(item.courseType);
      return this.format_course_type_list[type];
    },
    formatterCourseLocation(item) {
      const type = parseInt(item.courseLocation);
      return this.format_course_location_list[type];
    },
    // 编辑操作方法
    onEditRecord(row) {
      this.addCourseDialog.dialogRow = { ...row };
      this.addCourseDialog.stdName = row.studentName;
      this.addCourseDialog.courseDetails = this.courseDetails;
      // console.log(this.addCourseDialog.dialogRow);
      this.showAddCourseDialog();
    },
    onDeleteRecord(row) {
      var para = {
        id: row.id,
      };
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          deleteRecord(para).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            const para = {
              userName: getToken("USERNAME"),
              content:
                "删除完课课程中学员(" +
                row.studentName +
                ")操作,课程日期为:" +
                this.courseDetails.courseDate +
                ",课程时间段:" +
                this.courseDetails.courseTime +
                ",课程地点:" +
                this.courseDetails.courseLocation +
                ",班级类型:" +
                this.courseDetails.courseType,
            };
            addOperationRecord(para).then((res) => {
              console.log(res);
            });
            this.getCourseRecordList();
          });
        })
        .catch(() => {});
    },
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    selectTable(val, row) {
      this.setSearchBtn(val);
    },
    // 用户全选checkbox时触发该事件
    selectAll(val) {
      this.setSearchBtn(val);
    },
    setSearchBtn(val) {
      let isFlag = true;
      if (val.length > 0) {
        isFlag = false;
      } else {
        isFlag = true;
      }
      // this.$store.commit("SET_SEARCHBTN_DISABLED", isFlag);
    },
    onSubmitStudent(form) {
      let formData = this[form];
      formData.coursePackageId = formData.coursePackageAndMemberId.split(
        "-"
      )[0];
      formData.coursePackageAndMemberId = formData.coursePackageAndMemberId.split(
        "-"
      )[1];
      let id = {
        courseId: this.courseDetails.id,
      };
      const para = Object.assign(formData, id);
      console.log(para);
      addRecord(para).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: "添加学员成功",
            duration: 3000,
          });
          // this.$store.commit("SET_COURSE_DETAILS", res.data.data.courseDetails);
          const para = {
            userName: getToken("USERNAME"),
            content:
              "添加完课课程中学员(" + this.studentInForm.stdName + ")操作",
          };
          addOperationRecord(para).then((res) => {
            console.log(res);
          });
          this.addStudentDialogShow = false;
          this.getCourseRecordList();
          this.studentInForm = {
            courseId: "",
            stdName: "",
            telephoneNumber: "",
            coursePerformance: "",
            recordNote: "",
            coursePackageId: "",
            coursePackageAndMemberId: "",
          };
        } else {
          this.$message({
            type: "warning",
            message: res.data.msg,
            duration: 3000,
          });
          // this.addStudentDialogShow = false;
        }
      });
    },
    onSubmit(form) {
      //表单数据验证完成之后，提交数据;
      let formData = this[form];
      let id = {
        courseId: this.courseDetails.id,
      };
      const para = Object.assign({}, formData, id);
      console.log("id:" + para.courseId + ",coachName:" + para.coachName);
      blindCoach(para).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.$message({
            type: "info",
            message: "教练打卡成功",
            duration: 3000,
          });

          this.$store.commit("SET_COURSE_DETAILS", res.data.data.courseDetails);
          this.clockInDialogShow = false;
        } else if (res.data.code == 201) {
          this.$message({
            type: "info",
            message: "已经打卡",
            duration: 3000,
          });
          this.clockInDialogShow = false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.table_container {
  padding: 10px;
  background: #fff;
  border-radius: 2px;
}
.el-dialog--small {
  width: 600px !important;
}
.pagination {
  text-align: left;
  margin-top: 10px;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #409eff;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  text-align: center;
  color: #fff;
  font-weight: bold;
  min-height: 36px;
  line-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>


